<template>
  <section class="lublin-page__section">
    <div class="lublin-page__section-container">
      <h2 class="lublin-page__section-title">{{ sectionData.title }}</h2>

      <div class="lublin-page__section-content _nowrap">
        <div class="lublin-page__faq-list">
          <div
            v-for="(card, index) in sectionData.items"
            :key="index"
            class="lublin-page__faq-card"
            :class="{ _active: openAnswerIdx === index }"
            @click="setOpenAnswer(index)"
          >
            <div class="lublin-page__faq-card-header">
              <h4 class="lublin-page__faq-card-title">{{ card.item }}</h4>

              <button class="lublin-page__faq-card-expand-btn base-btn">
                <BaseSvg name="ico-chevron-down" width="1.6rem" height="0.77rem" />
              </button>
            </div>
            <CollapseTransition>
              <div
                v-if="openAnswerIdx === index"
                class="d-flex flex-column"
              >
                <div
                  v-html="card.text"
                  class="lublin-page__faq-card-content"
                ></div>
              </div>
            </CollapseTransition>
          </div>
        </div>

        <div
          v-if="!smOrDown"
          class="lublin-page__section-image-card border-colored-image-card"
        >
          <img
            :src="sectionData.image"
            alt="faq image"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import windowSizeMixin from '../../../mixins/windowSizeMixin';
import {CollapseTransition} from 'vue2-transitions'

export default {
  name: 'LublinFaqSection',
  components: {
    CollapseTransition,
  },
  mixins: [windowSizeMixin],
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openAnswerIdx: 0,
    };
  },
  methods: {
    setOpenAnswer(idx) {
      const alreadyOpen = this.openAnswerIdx === idx;
      if (alreadyOpen) {
        this.openAnswerIdx = -1;
        return;
      }
      this.openAnswerIdx = idx;
    },
  },
};
</script>
